function LoadMap(markers, google_markers) {
    var center = {
        'lat': (markers.length > 0)? markers[0].lat:-33.415951,
        'lng': (markers.length > 0)? markers[0].lng:-70.594756,
        'zo': (markers.length > 0)? markers[0].zo:13
    }

    // Esto es para retro compatibilidad.
    if (!google_markers){
        var google_markers = [];
    }

    var mapOptions = {
        center: new google.maps.LatLng(center.lat, center.lng),
        zoom: center.zo,
        scrollwheel: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles :[{
            "featureType": "all",
            "elementType": "geometry.fill",
            "stylers": [
                {"gamma": "5.58"},
                {"color": "#aae7e7"},
                {"saturation": "77"},
                {"lightness": "-8"},
                {"weight": "3.41"}
            ]},
            {
                "featureType": "administrative.province",
                "elementType": "all",
                "stylers": [
                    {"visibility": "off"}
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "geometry.stroke",
                "stylers": [
                    {"color": "#ff0000"}
                ]
            },
            {
                "featureType": "administrative.neighborhood",
                "elementType": "geometry.fill",
                "stylers": [
                    {"color": "#ff0000"}
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "geometry.fill",
                "stylers": [
                    {"saturation": "10"},
                    {"invert_lightness": true}
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {"saturation": -100},
                    {"lightness": 65},
                    {"visibility": "on"}
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.fill",
                "stylers": [
                    {"saturation": "-93"},
                    {"lightness": "37"}
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "geometry.stroke",
                "stylers": [
                    {"color": "#ff0000"}
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {"saturation": -100},
                    {"lightness": 51},
                    {"visibility": "simplified"}
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry.fill",
                "stylers": [
                    {"color": "#bfcacc"}
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {"saturation": -100},
                    {"visibility": "simplified"}
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {"color": "#d7dedf"}
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {"saturation": -100},
                    {"lightness": 30},
                    {"visibility": "on"}
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [
                    {"color": "#fffafa"}
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {"saturation": -100},
                    {"lightness": 40},
                    {"visibility": "on"}
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [
                    {"color": "#ffffff"}
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {"saturation": -100},
                    {"visibility": "simplified"}
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry.fill",
                "stylers": [
                    {"visibility": "on"}
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {"hue": "#eaf6f8"},
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {"visibility": "on"},
                    {"lightness": -25},
                    {"saturation": -100}
                ]
            }
        ]};

        // Creo el mapa y lo asigno en la variable global.
        map = new google.maps.Map(document.getElementById("map"), mapOptions);

        //Create and open InfoWindow.
        var infoWindow = new google.maps.InfoWindow();
 
        for (var i = 0; i < markers.length; i++) {
            var data = markers[i];

            var myLatlng = new google.maps.LatLng(data.lat, data.lng);

            var marker = new google.maps.Marker({
                position: myLatlng,
                map: map,
                title: data.title,
                animation:google.maps.Animation.DROP,
                icon: (data.icon)? data.icon:'/images/iconos/market.png',
                category: data.category
            });
 
            //Attach click event to the marker.
            (function (marker, data) {
                google.maps.event.addListener(marker, "click", function (e) {
                    //Wrap the content inside an HTML DIV in order to set height and width of InfoWindow.
                    infoWindow.setContent(
                                          '<div class="infoWindows">'+
                                          '<div class="imagen">'+'<img src="'+data.ruta+'"></div>'+
                                          '<div class="direccion">'+
                                              '<h5>'+data.title+'</h5>'
                                              +'<p>'+ data.description +'</p>'
                                              +'<a href="/">Municipalidad de Las Condes</a>'
                                          +'</div>'
                                      +'</div>');
                    infoWindow.open(map, marker); 
                });

            })(marker, data);

            marker.setMap(map);

            // Agrego el marker de Google en el array publico.
            google_markers.push(marker);
        }
}